import React from 'react';
import './SocialLinks.css';
import { FaTwitch, FaInstagram, FaDiscord, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";

const ICONS = {
  twitch: FaTwitch,
  twitter: FaXTwitter,
  tiktok: FaTiktok,
    instagram: FaInstagram,
    discord: FaDiscord,
};

function SocialLinks({ links = [] }) {
  const defaults = [
    { id: 'twitch', label: 'Twitch', url: 'https://twitch.tv/jizonn' },
    { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/noeliatwentyone/' },
      { id: 'discord', label: 'Discord', url: 'https://discord.gg/Bn4KryKjJ8' },
    { id: 'twitter', label: 'X', url: 'https://x.com/j1zoNN' },
    { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@noeliatwentyone' },
  ];

  const list = links.length ? links : defaults;

  return (
    <div className="social-links">
      <div className="social-list">
        {list.map((s) => {
          const Icon = ICONS[s.id] || FaTwitch;
          return (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              className={`social-link ${s.id}`}
              aria-label={s.label}
              title={s.label}
            >
              <Icon className="social-icon" />
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default SocialLinks;
